import { render, staticRenderFns } from "./TemplateFlowCancelButton.vue?vue&type=template&id=8f3e152a&"
import script from "./TemplateFlowCancelButton.vue?vue&type=script&lang=ts&"
export * from "./TemplateFlowCancelButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports